import { defaultIconProps, IconProps } from './IconProps';

export const IconCoin: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g clipPath="url(#clip0_411_1044)">
      <path
        d="M8.41752 3.33341C9.46963 2.30243 10.9106 1.66675 12.5 1.66675C15.7217 1.66675 18.3333 4.27842 18.3333 7.50008C18.3333 9.08953 17.6976 10.5305 16.6666 11.5826M13.3333 12.5001C13.3333 15.7217 10.7217 18.3334 7.50001 18.3334C4.27834 18.3334 1.66667 15.7217 1.66667 12.5001C1.66667 9.27842 4.27834 6.66675 7.50001 6.66675C10.7217 6.66675 13.3333 9.27842 13.3333 12.5001Z"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_411_1044">
        <rect width={size} height={size} fill={color} />
      </clipPath>
    </defs>
  </svg>
);

IconCoin.defaultProps = defaultIconProps;
